module.exports = __webpack_public_path__ + "img/logo.37f6a345.png";